import * as React from 'react'
import { useContext } from 'react';

const idContext = React.createContext("lqx");

export const LqxTitle = idContext.Provider;

export function useQaId( id : React.ReactNode ){
    return `${useContext( idContext )}-${ String( id ).toLowerCase() }`;
}

export type TitleWithQaId<T extends object> = T & (
    { title : string, 'qa-id'? : string } |
    { title : React.ReactNode, 'qa-id' : string }
)

export type ChildrenWithQaId<T extends object> = T & (
    { children : string, 'qa-id'? : string } |
    { children : React.ReactNode, 'qa-id' : string }
)